export default __webpack_public_path__ + "static/media/ian_chang.1008dd13.jpg";